(function(){
    //replace uppercase to regular case
    angular.module('tmx-app').filter('tel', tel);

    function tel() {
        return function (tel) {
            if (!tel) { return ''; }

            var value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            var country, city, number;

            switch (value.length) {
            case 1:
            case 2:
                country = value.slice(0,2);
            case 3:
                // city = value.slice(0,2);
                // break;
            case 4:
            case 5:
                country = value.slice(0,2);
                city = value.slice(2,5);
                break;

            default:
                country = value.slice(0,2);
                city = value.slice(2, 5);
                number = value.slice(5);
            }

            if(number){
                if(number.length>3){
                    number = number.slice(0, 3) + '-' + number.slice(3,7);
                }
                else{
                    number = number;
                }

                return ("+"+country+" (" + city + ") " + number).trim();
            }
            else if(city){
                return "+"+country+" (" + city;
            }
            else
                return "+"+country;   
        }
    }
})();
